import React from 'react'
import PropTypes from 'prop-types'

const ContainerFAQ = ({title, arrFaq, handleChangeFAQ, idGroup}) => {
  return (
    <div className="container_faq" data-block-type='1'>
      {title && <span className="title">{title}</span>}
      {arrFaq.map(faq => <button
        key={faq.id}
        id={faq.id}
        onClick={handleChangeFAQ(idGroup)}
        data-id-group={idGroup}
      >{faq.name ? faq.name.split('/:')[0] : ''}</button>)}
    </div>
  )
}

ContainerFAQ.propTypes = {
  arrFaq: PropTypes.array.isRequired,
  handleChangeFAQ: PropTypes.func.isRequired,
  idGroup: PropTypes.number,
  title: PropTypes.string,
}

export default ContainerFAQ